var n = /* @__PURE__ */ ((a) => (a.Graphql = "graphql", a.Contract = "contract", a.Unknown = "unknown", a.Manual = "manual", a))(n || {});
const t = 500;
export {
  t as MAX_SCREEN_LOGS,
  n as ScreenLogType
};
//# sourceMappingURL=screenLog.js.map
